<script>
  import { navigate } from 'svelte-routing';
  import { subscriptionRequired } from '../stores/authStore';

  function goToSettings() {
    subscriptionRequired.set(false);
    navigate('/settings');
  }

  function dismiss() {
    subscriptionRequired.set(false);
  }
</script>

{#if $subscriptionRequired}
  <div class="fixed z-50 inset-0 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center">
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full">
        <div class="bg-white px-6 pt-6 pb-4">
          <div class="flex items-start">
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-orange-100">
              <svg class="h-6 w-6 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          </div>
          <div class="mt-4 text-center">
            <h3 class="text-lg font-semibold text-gray-900">Subscription Required</h3>
            <p class="mt-2 text-sm text-gray-600">
              Your trial has ended. Please subscribe to continue using Buildzilla.
            </p>
          </div>
        </div>
        <div class="bg-gray-50 px-6 py-4 flex justify-end gap-3">
          <button
            on:click={dismiss}
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Dismiss
          </button>
          <button
            on:click={goToSettings}
            class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700"
          >
            View Plans
          </button>
        </div>
      </div>
    </div>
  </div>
{/if}
